"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hashCanonicalOperationPayload = exports.deriveCollectionInvitationExchangeToken = exports.canonicalizeOperationPayload = exports.normalizeVerifiedEmail = exports.normalizeCollectionName = exports.VERIFIED_EMAIL_MAX_CHARACTERS = exports.COLLECTION_NAME_MAX_CHARACTERS = void 0;
const values_1 = require("./values");
exports.COLLECTION_NAME_MAX_CHARACTERS = 80;
exports.VERIFIED_EMAIL_MAX_CHARACTERS = 254;
const normalizeCollectionName = (raw) => {
    if (typeof raw !== 'string')
        throw new Error('Collection name must be a string.');
    const name = raw.trim();
    if (!name || Array.from(name).length > exports.COLLECTION_NAME_MAX_CHARACTERS) {
        throw new Error(`Collection name must contain 1 to ${exports.COLLECTION_NAME_MAX_CHARACTERS} characters.`);
    }
    return {
        name,
        normalizedName: name.normalize('NFKC').replace(/\s+/gu, ' ').toLowerCase(),
    };
};
exports.normalizeCollectionName = normalizeCollectionName;
const normalizeVerifiedEmail = (raw) => {
    if (typeof raw !== 'string')
        throw new Error('Verified email must be a string.');
    const normalized = raw.trim().toLowerCase();
    const at = normalized.indexOf('@');
    if (!normalized ||
        Array.from(normalized).length > exports.VERIFIED_EMAIL_MAX_CHARACTERS ||
        at <= 0 ||
        at !== normalized.lastIndexOf('@') ||
        at === normalized.length - 1 ||
        /[\s\u0000-\u001f\u007f\u061c\u200e\u200f\u2028-\u202e\u2066-\u2069]/u.test(normalized)) {
        throw new Error('Verified email is invalid.');
    }
    return normalized;
};
exports.normalizeVerifiedEmail = normalizeVerifiedEmail;
const normalize = (value, path) => {
    if (value === null || typeof value === 'boolean' || typeof value === 'string')
        return value;
    if (typeof value === 'number') {
        if (!Number.isFinite(value))
            throw new Error(`Non-finite number at ${path}.`);
        return Object.is(value, -0) ? 0 : value;
    }
    if (Array.isArray(value)) {
        return value.map((entry, index) => normalize(entry, `${path}[${index}]`));
    }
    if (typeof value === 'object') {
        const prototype = Object.getPrototypeOf(value);
        if (prototype !== Object.prototype && prototype !== null) {
            throw new Error(`Unsupported object at ${path}.`);
        }
        return Object.keys(value)
            .sort()
            .reduce((result, key) => {
            const entry = value[key];
            if (entry === undefined)
                throw new Error(`Undefined value at ${path}.${key}.`);
            result[key] = normalize(entry, `${path}.${key}`);
            return result;
        }, {});
    }
    throw new Error(`Unsupported value at ${path}.`);
};
const canonicalizeOperationPayload = (payload) => JSON.stringify(normalize(payload, '$'));
exports.canonicalizeOperationPayload = canonicalizeOperationPayload;
const hexadecimal = (bytes) => Array.from(new Uint8Array(bytes), (byte) => byte.toString(16).padStart(2, '0')).join('');
const base64Url = (bytes) => {
    let binary = '';
    for (const byte of new Uint8Array(bytes))
        binary += String.fromCharCode(byte);
    return btoa(binary)
        .replace(/\+/gu, '-')
        .replace(/\//gu, '_')
        .replace(/=+$/gu, '');
};
const deriveCollectionInvitationExchangeToken = async (rawToken) => {
    var _a;
    if (typeof rawToken !== 'string' ||
        !/^[A-Za-z0-9_-]{32,512}$/u.test(rawToken)) {
        throw new Error('Invitation token is invalid.');
    }
    if (!((_a = globalThis.crypto) === null || _a === void 0 ? void 0 : _a.subtle))
        throw new Error('Web Crypto SHA-256 is unavailable.');
    const digest = await globalThis.crypto.subtle.digest('SHA-256', new TextEncoder().encode(`qkindex-invitation-exchange-v1\u0000${rawToken}`));
    return base64Url(digest);
};
exports.deriveCollectionInvitationExchangeToken = deriveCollectionInvitationExchangeToken;
const hashCanonicalOperationPayload = async (payload) => {
    var _a;
    if (!((_a = globalThis.crypto) === null || _a === void 0 ? void 0 : _a.subtle))
        throw new Error('Web Crypto SHA-256 is unavailable.');
    const canonical = (0, exports.canonicalizeOperationPayload)(payload);
    const digest = await globalThis.crypto.subtle.digest('SHA-256', new TextEncoder().encode(canonical));
    return {
        payloadHashVersion: values_1.OPERATION_PAYLOAD_HASH_VERSION,
        canonicalPayloadHash: hexadecimal(digest),
    };
};
exports.hashCanonicalOperationPayload = hashCanonicalOperationPayload;
